import React from 'react'
import { useParams } from 'react-router-dom'

import { Header } from 'src/components'
import { BottleParticipants } from 'src/components/ui'
import { useChangeBackground } from 'src/hooks/useChangeBackground'
import { useGetBottleById } from 'src/hooks/useGetBottleById'

import styles from './ParticipantsPage.module.scss'

const ParticipantsPage = () => {
  const { id } = useParams()
  useChangeBackground(styles['white-background'])

  const { bottleData } = useGetBottleById(id || '')

  return (
    <>
      <Header variant='settings' setting='Список учаників' path='..' />

      <main className={styles.main}>
        <BottleParticipants
          typeOfBottle={bottleData?.type}
          total_stars={bottleData?.total_stars || 0}
          total_tickets={bottleData?.total_tickets || 0}
          participantsList={bottleData?.participant_users}
          className={styles.main_title}
          variant='list'
        />
      </main>
    </>
  )
}

export default ParticipantsPage
